import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/home/runner/work/brand/brand/apps/docs/node_modules/@primer/gatsby-theme-doctocat/src/components/layout.js";
import ComponentLayout from '../../../src/layouts/component-layout';
export const _frontmatter = {};
const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};
const DoDontContainer = makeShortcode("DoDontContainer");
const Do = makeShortcode("Do");
const Caption = makeShortcode("Caption");
const Dont = makeShortcode("Dont");
const layoutProps = {
  _frontmatter
};
const MDXLayout = ComponentLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">




    <p><img parentName="p" {...{
        "src": "https://github.com/primer/brand/assets/6951037/3b8d5346-31d5-4820-baaf-056d9063f203",
        "alt": "An image showing a button group with a primary and a secondary button."
      }}></img></p>
    <h2>{`Usage`}</h2>
    <p>{`Use button group to group a set of actions that are related between them or to a single application. E,g, "Log in" and "Sign up" or "Try it out" and "Learn more".`}</p>
    <p>{`Use button group to display a pair of primary and a secondary actions. The primary button is used for the main call to action while the secondary button is a related, less important action.`}</p>
    <DoDontContainer mdxType="DoDontContainer">
  <Do mdxType="Do">
    <img src="https://github.com/primer/brand/assets/6951037/c69ae38e-819b-4e03-9b92-665a479f188a" />
    <Caption mdxType="Caption">Use a primary button with a secondary button.</Caption>
  </Do>
  <Dont mdxType="Dont">
    <img src="https://github.com/primer/brand/assets/6951037/c4c5c0de-2a46-4dbb-802a-0a6739d31d3a" />
    <Caption mdxType="Caption">Don’t place multiple primary buttons together.</Caption>
  </Dont>
    </DoDontContainer>
    <DoDontContainer mdxType="DoDontContainer">
  <Do mdxType="Do">
    <img src="https://github.com/primer/brand/assets/6951037/9918ba9b-57ea-4a32-b51b-2460554900a9" />
    <Caption mdxType="Caption">
      Place the primary button at the beginning of a button group.
    </Caption>
  </Do>
  <Dont mdxType="Dont">
    <img src="https://github.com/primer/brand/assets/6951037/cb151d26-2597-45e7-b271-62d64c3c292d" />
    <Caption mdxType="Caption">
      Don't place the primary button at the end of a button group.
    </Caption>
  </Dont>
    </DoDontContainer>
    <DoDontContainer mdxType="DoDontContainer">
  <Do mdxType="Do">
    <img src="https://github.com/primer/brand/assets/6951037/97f95652-8802-418a-bf4b-7d9800c038fc" />
    <Caption mdxType="Caption">
      Stack the buttons vertically when there's not enough horizontal space.
    </Caption>
  </Do>
  <Dont mdxType="Dont">
    <img src="https://github.com/primer/brand/assets/6951037/ef165552-94e1-4377-a9db-d8e9355af4eb" />
    <Caption mdxType="Caption">
      Don't stack the buttons horizontally when there's not enough space to
      avoid text wrapping.
    </Caption>
  </Dont>
    </DoDontContainer>
    <h2>{`Options`}</h2>
    <h3>{`Size`}</h3>
    <p>{`The button group component has two sizes: `}<inlineCode parentName="p">{`medium`}</inlineCode>{` and `}<inlineCode parentName="p">{`large`}</inlineCode>{`. The `}<inlineCode parentName="p">{`medium`}</inlineCode>{` size should be used for most cases. The `}<inlineCode parentName="p">{`large`}</inlineCode>{` size should be used when the button group is used in large headings that introduces a page, as in the `}<a parentName="p" {...{
        "href": "/brand/components/Hero"
      }}>{`Hero`}</a>{` component.`}</p>
    <h2>{`Related components`}</h2>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "/brand/components/Button"
        }}>{`Button`}</a>{`: To display a button that performs an action.`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "/brand/components/Link"
        }}>{`Link`}</a>{`: To display a link that navigates to another page.`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "/brand/components/Hero"
        }}>{`Hero`}</a>{`: To display a large heading and a description with a button group.`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "/brand/components/CTABanner"
        }}>{`CTA banner`}</a>{`: To draw attention to or create urgency around a user action.`}</li>
    </ul>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      